export default __webpack_public_path__ + "static/media/Roboto-ThinItalic.35d37b3f.ttf";